import Styled from "styled-components";

export const SidebarContainer = Styled.div`
height: calc(100vh - 67px);
.pro-sidebar {
  width: 220px;
  min-width: 220px;
  position: relative;
  .pro-sidebar-inner{
  background: #ffffff;
  border-right: 1px solid #e6e6e6;
}
}
.pro-sidebar.collapsed {
    width: 60px !important;
    min-width: 60px !important;
}
li.pro-menu-item.pro-sub-menu.open > .pro-inner-item {
  background: #F9F9F9;
}
li.pro-menu-item.pro-sub-menu{
.submenu-item {
padding: 0px;
margin-left: 40px;
} 

}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
    padding: 3px 18px 3px !important;
}
li.pro-menu-item.submenu-item.active .pro-inner-item {
    font-weight: 600;
}
li.pro-menu-item.pro-sub-menu.active.open {
    border-color: transparent;
    svg{
    color: #1565D8 !important;
    }
}
li.pro-menu-item.submenu-item.active span.pro-item-content {
    color: #1565D8 !important;
    font-weight:600;
}
li.pro-menu-item.pro-sub-menu .submenu-item {
    padding: 0px;
    margin-left: 16px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul{
  padding: 0 !important;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item{
padding: 10px 38px 10px 8px;
}
.react-slidedown.pro-inner-list-item {
  padding: 0px !important;
}
.pro-sidebar-logo {
  padding: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #4285f4;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pro-icon-wrapper {
  background-color: transparent;
  color: #000;
}
.pro-menu-item {
  color: #000;
  font-weight: 400;
  &:hover{
  color: #000 !important;
  }
}
.submenu-item {
  padding-left: 40px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
        background-color: ${({ theme }) => theme["white-color"]} !important;
        padding-left: 20px;
        border-radius: 4px;
        box-shadow: 8px 0px 12px rgba(0, 0, 0, 0.12);
        ul{
            li{
                display: block;

                &.after{
                    border-bottom:none!important
                }
            }
        }
     }
     .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner{
      padding:8px !important;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
     }
     .pro-sidebar.collapsed .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
    padding: 3px 18px 3px !important;
    background: transparent;
}
     .pro-sidebar.collapsed li.pro-menu-item.pro-sub-menu{
      background: transparent !important;
     }
     .pro-sidebar.collapsed li.pro-menu-item.pro-sub-menu .submenu-item{
      margin: 0 !important;
     }
.pro-sub-menu .pro-inner-item {
  span.pro-arrow{
    border-color: #4E5969 !important;

  }
  .pro-icon{
    svg{
    fill: #4E5969;
      }
  }
  .pro-item-content{
    color: #4E5969;
  }
}
.pro-inner-item{
.pro-item-content{
    color: #4E5969;
  }
  .pro-icon{
    svg{
    fill: #4E5969;
      }
  }
}
.pro-sub-menu.open .pro-inner-item {
  background-color: #fff !important;
  span.pro-arrow{
    border-color: #1565D8 !important;

  }
  .pro-icon{
    svg{
    fill: #1565D8 !important;
      }
  }
  .pro-item-content{
    color: #1565D8;
    font-weight:400;
  }
}
li.pro-menu-item {
  margin-left: 1px;
  border-left:1px solid transparent;
}
.pro-item-content{
  user-select:none;
}
li.pro-menu-item.active {
  border-left: 1px solid #1565D8;
  margin-left: 1px;
  .pro-item-content{
    color: #1565D8;
    font-weight: 400;
  }
  svg{
    fill: #1565D8 !important;
      }
}
li.pro-menu-item.submenu-item .pro-inner-item span {
  color: #4E5969 !important;
}
.pro-sub-menu.open div.pro-inner-item > .pro-item-content{
    color: #1565D8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  color: #000 !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #F9F9F9;
  margin-top: 2px;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #000 !important;

}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item{
background-color: transparent;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper{
background-color: transparent;
}
`;
export const UserPopoverContentWrapper = Styled.div`
width: 150px;
.popover-btn {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    cursor: pointer;
    border: 1px solid #1565D8;
    padding: 4px;
    border-radius: 4px;
    justify-content: center;
    &:hover{
      background: #1565D8;
      p, svg{
        color: #fff;
      }
    }
    p {
    margin: 0;
    font-size: 14px;
    color: #1565D8;
    font-weight: 600;
}
svg {
    font-size: 16px;
    color: #1565D8;
}
}
`

export const Header = Styled.div`
    padding: 9px 16px;
    background: #1565D8;
    color: #fff;
    display: flex;
    justify-content: space-between;
    span.icon-wrapper {
    position: absolute;
    left: ${({collapsed}) => collapsed ? '48px' : '208px'} ;
    top: 50px;
    z-index: 9682;
    background: #1565d8;
    width: 23px;
    height: 23px;
    transition: left ease 0.3s;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
}
    .logo-page-title {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 217px);
    align-items: center;
    .page-title {
      display: flex;
      align-items:center;
      grid-gap:12px;
      span {
      font-size: 14px;
      font-weight: 400;
      color: #F8FAFB;
      &:not(:last-child){
        color: #DDE3EC80;
      }
}
    }
      .file-upload-section{
        height: 30px;
        width: 56vw;
        display: flex;
        background-color: #FFFFFF73;
        color: black;
        padding: 0px 16px;
        border-radius: 5px;
        grid-gap: 0px;
        align-items: center;
        justify-content: space-around;
        overflow: auto;
          &::-webkit-scrollbar {
            display: none;
          }
        scrollbar-width: none;
        -ms-overflow-style: none;
        .file-info {
          display: flex;
          align-items: center;
          grid-gap: 4px;
            span:nth-of-type(2) {
              max-width: 6vw
            }
          span {
            max-width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            font-weight: 400;
            color: #0000007D;
            &:not(:first-child) {
              font-size: 12px;
              font-weight: 700;
              color: #22413C;
            }
          }
          span.count-cal {
              font-size: 12px;
              color: #fff !important;
              border: 1px solid #FFFFFF;
              width: 32px;
              height: 18px;
              border-radius: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
          }
          .header-bar-placement {
              min-width: 119px;
          }
        }
      }
    .actions {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    .user-title {
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      border-radius: 50px;
      width: 30px;
      background: #fff;
      color: #1565D8;
      padding: 8px;
      position: relative;
      cursor: pointer;
      img {
        position: absolute;
        bottom: 0px;
        right: 0px;
      }
    }
.divider {
    width: 1px;
    background: #FFFFFF80;
    height: 22px;
}
}
}
`

const Div = Styled.div`
.pro-sidebar {
  color: #adadad;
  text-align: left;
  transition: width, left, right, 0.3s;
  border-right:1px solid;
  z-index: 1009; }
  .pro-sidebar > .pro-sidebar-inner {
    height: 100%;
    position: relative;
    z-index: 101; }
    .pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
      object-fit: cover;
      object-position: center;
    }
    .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      display: flex;
      flex-direction: column;
      padding:14px 12px;
      z-index: 101; }
      .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
        border-bottom: 1px solid rgba(173, 173, 173, 0.2); }
      .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
        flex-grow: 1; }
      .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
        border-top: 1px solid rgba(173, 173, 173, 0.2); }
      .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
     }
     .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .inner-submenu-arrows {
        list-style-type: none;
        padding: 0;
        margin: 0;
     }
  .pro-sidebar .overlay {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
  }
  .pro-sidebar.collapsed {

  box-shadow: none!important;
  }
  .pro-sidebar.rtl {
    text-align: right;
    direction: rtl; }

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: '';
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad; }

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px; }
  .pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
    position: relative;
    background-color: ${({ theme }) => theme["white-color"]};
 }
  .pro-sidebar .pro-menu a {
    text-decoration: none;
    color: #adadad; }
    .pro-sidebar .pro-menu a:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: transparent; }
    .pro-sidebar .pro-menu a:hover {
      color: #d8d8d8; }
  .pro-sidebar .pro-menu .pro-menu-item {
    font-size: 15px; }
     .pro-sidebar {
	    .pro-menu {
		.pro-menu-item {
      border-bottom:1px solid rgba(221, 227, 236, 0.5);

          &:last-child{
            border-bottom:none;
          }
          .pro-inner-list-item{
            .active{
              .pro-inner-item{
              .pro-item-content{
                  color: ${({ theme }) => theme["primary-color"]};
                  border-left:1px solid ${({ theme }) => theme["primary-color"]}; ;
              }
            }
			} 
            }
          }
          &.active{
            .pro-inner-item{
              .pro-icon-wrapper{
                .pro-icon{
                  span::before{
                    color: ${({ theme }) => theme["primary-color"]};
                  }
                }
              }
              .pro-item-content{
                  color: ${({ theme }) => theme["primary-color"]};
              }
            }
			} 
          }
            
            &.pro-sub-menu{
                .react-slidedown{
                .pro-menu-item{
                      border-bottom:none;
            }
            }  
             
            }
         
            
			}
		}
        &.no-border{
            .pro-inner-item {
				.pro-item-content {
					border-left: none;
					color: #4E5969;
          a{
            color: #4E5969;
            padding-left:0
          }
				}
			} 
        }
    }
}
	}
}
     .pro-sidebar .pro-menu .pro-menu-item.active .pro-inner-item .pro-icon-wrapper .pro-icon{
      color: #1565D8;
     }
    .pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
      opacity: 1;
      transition: opacity 0.2s; }
    .pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
      display: flex;
      margin-right: 5px;
      opacity: 1;
      transition: opacity 0.2s; }
    .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 8px 35px 8px 0px;
      margin: 0px 0;
      cursor: pointer; }
      .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
        outline: none;
        color: #d8d8d8; }
      .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
        margin-right: 7px;
        font-size: 16px;
        width: 35px;
        min-width: 35px;
        height: 35px;
        line-height: 35px;
        color: ${({ theme }) => theme["black-color"]};
        text-align: center;
        display: inline-block; }
        .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center; }
      .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content  {
        flex-grow: 1;
        color: ${({ theme }) => theme["secondary-color"]};
        flex-shrink: 1;
        padding-left:0px;
     }
     .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-list-item  .pro-inner-item .pro-item-content  {
      padding-left:10px;
     }
     .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content  a {
        flex-grow: 1;
        color: ${({ theme }) => theme["secondary-color"]};
        flex-shrink: 1;
     }
      .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
        color: #d8d8d8; }
        .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
          animation: swing ease-in-out 0.5s 1 alternate; }
    .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
      background: #adadad; }
    .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%); }
      .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
        display: inline-block;
        border-style: solid;
        border-color: ${({ theme }) => theme["primary-color"]};
        border-width: 0 2px 2px 0;
        padding: 2.5px;
        vertical-align: middle;
        transition: transform 0.3s;
        transform: rotate(45deg); }
    .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
      background: transparent !important; }
    .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
      transform: rotate(-134deg); }
    .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
      padding-left: 26px; }
      /* .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
        padding: 4px 30px 4px 24px; } */
        .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
          background: none;
          width: auto;
          min-width: auto;
          height: auto;
          line-height: auto; }
  .pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
    display: none; }
  .pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
     }
  .pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
    border-radius: 0; }
  .pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
    border-radius: 4px; }
  .pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
    border-radius: 50%; }

.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative; }
  .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
  .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
    opacity: 0; }
  .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
    background-color: #2b2b2b;
    z-index: 111; }
  .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    cursor: pointer; }
  .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
    position: relative; }
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
      pointer-events: none; }
      .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
        display: none; }
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
      height: auto !important;
      position: fixed;
      visibility: hidden;
      background-color: transparent;
      max-height: 100%;
      padding-left: 3px; }
      .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
        padding-left: 10px; }
      .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
        max-height: 100vh;
        overflow-y: auto;
        background-color: ${({ theme }) => theme["white-color"]} !important;
        padding-left: 20px;
        border-radius: 4px;
        box-shadow: 8px 0px 12px rgba(0, 0, 0, 0.12);
        ul{
            li{
                display: block;
                &.after{
                    border-bottom:none!important
                }
            }
        }
     }
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
      transition: visibility, transform 0.3s;
      visibility: none; }
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
      animation: swing ease-in-out 0.5s 1 alternate; }
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
    .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
      padding: 8px 30px 8px 5px; }

.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px; }

.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px; }
  .pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
    margin-right: 0;
    margin-left: 10px; }

.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px; }
  .pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
    transform: rotate(135deg); }

.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg); 
}
.pro-sidebar .pro-menu .pro-menu-item.open .pro-inner-item,
.pro-sidebar .pro-menu .pro-menu-item.active .pro-inner-item {
  background-color:#fff ;
}
.pro-sidebar .pro-menu .pro-menu-item.open .pro-inner-item .pro-icon-wrapper .pro-icon span::before,
.pro-sidebar .pro-menu .pro-menu-item.active .pro-inner-item .pro-icon-wrapper .pro-icon span::before {
  color:#1565d8;
}
.pro-sidebar .pro-menu .pro-menu-item.open > div:first-of-type .pro-item-content,
.pro-sidebar .pro-menu .pro-menu-item.active > div:first-of-type .pro-item-content {
  color:#1565d8;
  font-weight: ${({ theme }) => theme["bold-weight"]};
}

.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px; }
  .pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
    padding: 8px 15px 8px 30px; }
    .pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
      margin-right: 0;
      margin-left: 15px; }

.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px; }
  .pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
    padding-right: 10px; }
  .pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
    padding-left: 0;
    padding-right: 20px; }

.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px; }

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent; }

.popper-element[data-popper-placement^='left'] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b; }

.popper-element[data-popper-placement^='right'] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b; }

.react-slidedown {
    ul{
        padding-top:10px!important;
    }
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out; }

.react-slidedown.transitioning {
  overflow-y: hidden; }

.react-slidedown.closed {
  display: none; }
  .pro-inner-list-item{
      .popper-inner{
          display: block;
      }
      ul{
          li{
                  border-bottom:none!important;
              }
          }
     }
  .sidebar-collapsed{
    width: 100%;
    height: 100vh;
    overflow: hidden;
  
    /* padding-left: 60px;  */
    .pro-sidebar{

     box-shadow: 8px 0px 12px rgba(0, 0, 0, 0.12);
    }
  }
       `;

const Content = Styled.div`
  padding:12px 24px;
  width:100%;
  /* height: 100vh; */
  overflow-y: auto;
  overflow-x: hidden;
  /* margin-left: 64px; */
  z-index: 0;
  .collapsed-none{
    transition: all .2s;
  }
  /* filter: ${(props) => (props.makeBlur ? 'blur(5px)' : 'blur(0px)')}; */
`;

export const MobileContent = Styled.div`
padding: 24px;
height: calc(100vh - 65px);
overflow: auto;
`;

export { Div, Content };
